/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * The error component for Chart
 *
 * @author Maxim Fedorov
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.1.0
 */

import { cloneElement, FC, Fragment } from 'react';

import { icons } from '../../../assets';
import { ImgStyled } from '../Block/Img';
import { IChartProps } from './Chart';
import { getChartImplementation } from './ChartsImplementation/chartImplementation';
import { IChartImplementation } from './ChartsImplementation/chartImplementationTypes';
import {
    ChartEmptyTextStyled,
    ChartErrorContainerStyled,
    ChartErrorTextStyled,
    ChartSubTextStyled,
} from './styled/ChartErrorStyled';

const ChartError: FC<IChartProps> = props => {
    const chartImplementation: IChartImplementation = getChartImplementation(props.type);
    return cloneElement(chartImplementation.render(), {}, (
        <Fragment>
            <ChartErrorContainerStyled>

                {
                    props.isError
                        ?
                        <Fragment>
                            <ImgStyled className="medium" src={icons.infoBlackIcon}/>
                            <ChartErrorTextStyled>{props.translation?.errorText}</ChartErrorTextStyled>
                        </Fragment>
                        :
                        <Fragment>
                            <ChartEmptyTextStyled>{props.translation?.notData}</ChartEmptyTextStyled>
                            <ChartSubTextStyled>
                                {props.translation?.subText}
                            </ChartSubTextStyled>
                        </Fragment>
                }

            </ChartErrorContainerStyled>
        </Fragment>
    ));
};

export default ChartError;
